import React, { Component } from 'react'
import Layout, { ILayoutProps } from '../layout/layout'
import Loading from '../loading/loading'

interface IAsyncComponentState {
  component?: any
}

const asyncComponent = (importComponent: any, props: ILayoutProps) => {
  return class extends Component {
    state: IAsyncComponentState = {
      component: undefined,
    }
    componentDidMount() {
      importComponent().then((cmp: any) => {
        this.setState({ component: cmp.default })
      })
    }
    render() {
      const Component = this.state.component
      return Component ? (
        <Layout {...props}>
          <Component />
        </Layout>
      ) : (
        <Loading />
      )
      // <Loading/>
    }
  }
}

export default asyncComponent
